<template>
  <section>
    <div class="blocked_warning">
      <div class="icon">
        <font-awesome-icon icon="exclamation-circle"></font-awesome-icon>
      </div>
      <div class="content">
        <div class="tips">
          This customer has the following warning(s).
        </div>
        <div class="list">
          <ul>
            <li
              v-for="(item, i) in customerProfile.block_data"
              :key="i">
              Blocked({{blockName(item)}})
            </li>
            <li
              v-if="customerProfile.block_reference_nm"
              class="list-style__none">Reference Name : {{customerProfile.block_reference_nm}}</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'BlockWarning',
  mixins: [MixinOptions],
  props:{
    customerProfile:{
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  computed:{
    classList(){
      let arr = this.globalOptions.class_data.filter(item => item.id < 50) || []
      arr.unshift({
        id: 0,
        name: 'All'

      })
      return arr
    },
    blockName(){
      let arr = this.classList||[]
      return(name)=>{
        let result = ''
        arr.some(item => {
          if (item.id == name) {
            result = item.name
            return true
          }
          return false
        })
        return result
      }

    }
  },
  methods: {

  },
}
</script>
<style lang='scss' scoped>
.blocked_warning{
  padding: 15px;
  display: flex;
  background: #FFE3E6;
  border: 1px solid rgba(158, 28, 35, 0.2);
  border-radius: 6px;
  .icon{
    font-size: 14px;
    color: #CB2431;
  }
  .content{
    margin-left: 16px;
    .tips{
      font-weight: 600;
      font-size: 14px;
      color: #24292E;
    }
    .list{
      margin-top: 15px;
      ul{
        padding-left: 20px;
        li{
          font-weight: 400;
          font-size: 14px;
          color: #24292E;
          line-height: 20px;
          &.list-style__none{
            list-style: none;
          }
        }
      }
    }
  }
}
</style>
